export default __webpack_public_path__ + "media/images/icons/chevron-up-solid-ba714d3187830dd385006d2cdeb8a4d6.svg";